export default __webpack_public_path__ + "static/media/Icon feather_calendar.8f370d40.svg";